import { Card, CardContent, Grid, Typography } from '@material-ui/core';
import { useKeycloak } from '@react-keycloak/web';
import * as authActions from 'app/auth/store/actions';
import { link } from 'app/utils/coresUtil';
import { CLIENTS_ID, getClientId } from 'app/utils/enviromentUtil';
import { logoFM, logoGF } from 'app/utils/imagensUtil';
import React from 'react';
import { FaLock } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { sessaoBloqueadaStyles } from './styles/Styles';

const SessaoBloqueada = () => {
  const styles = sessaoBloqueadaStyles();
  const logo = getClientId() === CLIENTS_ID.financeiroFront ? logoFM : logoGF;
  const { keycloak } = useKeycloak();
  const dispatch = useDispatch();

  return (
    <div className={styles.container}>
      <Card className={styles.card}>
        <CardContent className={styles.cardContent}>
          <Grid container spacing={3}>
            <img src={logo} alt="logo" />

            <Grid item xs={12}>
              <div className={styles.icone}>
                <FaLock />
              </div>
            </Grid>

            <Grid item xs={12}>
              <Typography style={{ textAlign: 'center', marginBottom: '1.6rem', width: '100%' }}>
                Acesso não permitido.
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography style={{ textAlign: 'center', width: '100%' }}>
                Verifique sua permissão de acesso ao sistema com o responsável.
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <div className={styles.linkVoltar}>
                <Link
                  to="/login"
                  style={{ color: link }}
                  onClick={() => {
                    if (!window.location.href.includes('/public')) {
                      dispatch(authActions.logoutUser());
                      window.location = keycloak.createLogoutUrl();
                    }
                  }}
                >
                  Voltar para login
                </Link>
              </div>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </div>
  );
};

export default SessaoBloqueada;
